import { SimpleWrapper } from "components/InputsMex/containers";
import { SeleccionarFecha } from "components/InputsMex/inputs";
import { Button } from "primereact/button";
import React from "react";
import COLORS from "utils/constants/COLORS";

export const Vigencia = ({
  fechaInicio = "",
  fechaFin = "",
  preload = null,
  regresar = () => {},
  onClickSiguiente = () => {},
}) => {
  return (
    <React.Fragment>
      <div className='row d-flex justify-content-center'>
        <div className='col-md-5 col-12'>
          <form onSubmit={(e) => e.preventDefault()}>
            <SimpleWrapper
              name='fechaInicioVigencia'
              label='Por favor, seleccione el inicio de vigencia de la póliza'>
              <SeleccionarFecha
                name='fechaInicioVigencia'
                fechaInicio={fechaInicio}
                preload={preload}
                fechaFin={fechaFin}
                rules={{ required: "Por favor seleccione una fecha" }}
              />
            </SimpleWrapper>
          </form>
        </div>
      </div>
      <div className='col-md-12 mt-5'>
        <div className='row justify-content-center'>
          <div className='col-12 d-flex flex-wrap justify-content-center'>
            <div className='col-md-3 col-sm-12 mt-1'>
              <Button
                onClick={() => {
                  regresar();
                }}
                type='button'
                textColor='white'
                bgColor={COLORS.primary}
                className='btn-boton-siguiente-atras col-12'>
                <i
                  className='pi pi-arrow-left mx-3'
                  style={{
                    position: "relative",
                    top: "1px",
                    fontSize: "1.4rem",
                    textAlign: "center",
                  }}
                />{" "}
                Atrás
              </Button>
            </div>
            <div className='col-md-3 col-sm-12 mt-1'>
              <Button
                textColor='white'
                bgColor={COLORS.primary}
                onClick={onClickSiguiente}
                className='btn-boton-siguiente-atras col-12'>
                Continuar{" "}
                <i
                  className='pi pi-arrow-right mx-3'
                  style={{
                    position: "relative",
                    top: "1px",
                    fontSize: "1.4rem",
                    textAlign: "center",
                  }}
                />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
